import { create } from "zustand";
import { devtools } from "zustand/middleware";

type TokenStore = {
  token: string;
  setToken: (value: string) => void;
};

export const tokenStore = create<TokenStore>()(
  devtools<TokenStore>(
    (set) => ({
      token: "",
      setToken: (value) => {
        set({ token: value });
      },
    }),
    {
      name: "TokenStore",
      enabled: process.env.NODE_ENV === "development",
    }
  )
);
